import React from "react";

const SubAgent = () => {
  return <div>you are not reseller. to be a reseller please contact admin.</div>;
};

export default SubAgent;
